import { render } from "./OffertaDialog.vue?vue&type=template&id=4da82f84"
import script from "./OffertaDialog.vue?vue&type=script&lang=js"
export * from "./OffertaDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__